(function($) {
    $(() => {

        $(document).ready(function() {
            $('.js-active-filter').trigger('click');
        });

        /* Trigger on click to filter */
        $('.js-filter-news-input').on('input', function(e) {
            e.preventDefault();
            $('.js-active-filter').trigger('click');
        });
        
        $('.js-news-filter').on('click', function(e) {
            e.preventDefault();
            $('.js-no-results').removeClass('show');

            /* Get the filter slug */
            const slug = $(this).data('slug');
         
            /* Add active and remove inactiv calsses */
            $('.js-news-filter').removeClass('btn-primary btn-primary--small js-active-filter').addClass('btn-secondary btn-secondary--small');
            $(this).removeClass('btn-secondary btn-secondary--small').addClass('btn-primary btn-primary--small js-active-filter');

            /* Pass the filter slug and search input value to the BE */
            $.ajax({
                url: ajax.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'filter_news',
                    slug: slug,
                    text: $('.js-filter-news-input').val()
                },
                success(data) {
                    $('.js-filter-news-wrapper').html(data.html);
                    if (parseInt(data.page) <= 9) {
                        $('.js-get-more-news').hide();
                    } else {
                        $('.js-get-more-news').show();
                    }
                    $(document).ready(function () {
                        $('.match-h').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });    
                    });
                  
                    if(data.page == 0) {
                        $('.js-get-more-news').hide();
                        $('.js-no-results').addClass('show');
                    }
                }
            }).done(response => {
                
            });
        });

        /* Get more news */
        $('.js-get-more-news').on('click', function(e) {
            e.preventDefault();

            /* Get the listed items for post_not__in */
            let post_ids = [];
            $('.card-news-big').each(function( index ) {
                post_ids.push($(this).data('id'));
            });

            $('.card-news').each(function( index ) {
                post_ids.push($(this).data('id'));
            });
            
            /* Pass the filter slug and search input value to the BE */
            $.ajax({
                url: ajax.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'get_more_news',
                    slug: $('.js-active-filter').data('slug'),
                    text: $('.js-filter-news-input').val(),
                    post_ids
                },
                success(data) {
                    $('.js-filter-news-wrapper').append(data.html);
                    if (parseInt(data.page) <= 8) {
                        $('.js-get-more-news').hide();
                    } else {
                        $('.js-get-more-news').show();
                    }
                    $(document).ready(function () {
                        $('.match-h').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });    
                    });
                }
            }).done(response => {
               
            });
        });

        /* Get more activities */
        $('.js-get-more-news-activities').on('click', function(e) {
            e.preventDefault();

            /* Get the listed items for post_not__in */
            let post_ids = [];

            $('.card-news').each(function( index ) {
                post_ids.push($(this).data('id'));
            });

           
            
            /* Pass the filter slug and search input value to the BE */
            $.ajax({
                url: ajax.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'get_more_news_activities',
                    categories: JSON.parse($('.js-category').val()),
                    text: $('.js-filter-news-input').val(),
                    post_ids
                },
                success(data) {
                    $('.js-filter-news-wrapper').append(data.html);
                    if (parseInt(data.page) <= 4) {
                        $('.js-get-more-news-activities').hide();
                    } else {
                        $('.js-get-more-news-activities').show();
                    }
                    $(document).ready(function () {
                        $('.match-h').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });    
                    });
                }
            }).done(response => {
               
            });
        });
    });
})(jQuery);
